import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/svg/info-danger.svg'
import _imports_1 from '@/assets/svg/info-success.svg'


const _hoisted_1 = { class: "no-break cursor-pointer" }
const _hoisted_2 = { class: "relative rounded-md overflow-hidden hover-trigger" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "text-center"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "w-9 mb-3 m-auto",
  src: _imports_0
}, null, -1)
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = {
  key: 2,
  class: "text-center"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  class: "w-9 mb-3 m-auto",
  src: _imports_1
}, null, -1)
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = { class: "absolute bottom-0 flex justify-between items-center w-full px-4 mb-2 text-9 md:text-14" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DownloadSizesSelect = _resolveComponent("DownloadSizesSelect")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: [
          !_ctx.isError && !_ctx.isSuccess ? 'hover-target' : 'flex',
          `absolute bg-image-hover bg-opacity-75 text-white w-full
           h-full justify-center items-center`
        ]
          }, [
            _createVNode(_component_DownloadSizesSelect, {
              class: "absolute top-2 right-2",
              modelValue: _ctx.selectedDownloadSize,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedDownloadSize = $event)),
              downloadOptions: _ctx.downloadOptions
            }, null, 8, ["modelValue", "downloadOptions"]),
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('actions.downloading')), 1))
              : _createCommentVNode("", true),
            (_ctx.isError)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('messages.download-failed')), 1),
                  _createVNode("button", {
                    class: "underline mt-3 hover:opacity-50",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDownload && _ctx.onDownload(...args)))
                  }, _toDisplayString(_ctx.$t('actions.try-again')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSuccess)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('messages.downloaded')), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isLoading && !_ctx.isError && !_ctx.isSuccess)
              ? (_openBlock(), _createBlock("button", {
                  key: 3,
                  class: "hover:opacity-50",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDownload && _ctx.onDownload(...args)))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'cloud-download-alt'],
                    class: "mr-2 text-18"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('actions.download')), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_10, [
              (_ctx.item.database === 'unsplash')
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    (_ctx.item.author.url)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          href: `${_ctx.item.author.url}?utm_source=imagesuggest&utm_medium=referral`,
                          target: "blank"
                        }, [
                          _createVNode("u", null, _toDisplayString(_ctx.item.author.username || _ctx.item.author.name), 1)
                        ], 8, ["href"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.item.database === 'pexels')
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    (_ctx.item.author.url)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          href: _ctx.item.author.url,
                          target: "blank"
                        }, [
                          _createVNode("u", null, _toDisplayString(_ctx.item.author.username || _ctx.item.author.name), 1)
                        ], 8, ["href"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.item.database === 'pixabay')
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    _createVNode("a", {
                      href: `https://www.${_ctx.item.database}.com/users/${_ctx.item.author.username }`,
                      target: "blank"
                    }, [
                      _createVNode("u", null, _toDisplayString(_ctx.item.author.username || _ctx.item.author.name), 1)
                    ], 8, ["href"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", null, [
                _createVNode("a", {
                  href: _ctx.item.database === 'unsplash'
                ? `https://www.${_ctx.item.database}.com?utm_source=imagesuggest&utm_medium=referral`
                : `https://www.${_ctx.item.database}.com`,
                  target: "blank"
                }, _toDisplayString(_ctx.$t(`dashboard.databases.${_ctx.item.database}`)), 9, ["href"])
              ])
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createVNode("img", {
        class: "w-full",
        src: _ctx.item.thumbnail.url,
        onLoad: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('load'))),
        onError: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onError(_ctx.item)))
      }, null, 40, ["src"])
    ])
  ]))
}